//展示用户上传的打点场地信息

import { Card, Image, Flex } from 'antd';
import { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import './index.scss'
import { getSelectedPhotoAPI, getShowLocationListByUserIdAPI } from '@/apis/showLocation';
import { SERVER_CONF } from '@/config/server'
import { useSelector } from 'react-redux';

const BASE_SERVER_URL_LOCAL = SERVER_CONF.BASE_URL

const MyShowLocationDisplay = () => {
    const { t } = useTranslation();

    const userId = useSelector(state => state.user.userInfo.userId)
    const [showLocationList, setShowLocationList] = useState([])

    useEffect(() => {
        //通过接口获取打点地点数据
        async function getShowLocationListByUserId() {
            if (userId != null) {
                const res = await getShowLocationListByUserIdAPI(userId)
                const resultList = res.data
                setShowLocationList(resultList)
            }
        }
        getShowLocationListByUserId()
    }, [userId])

    //通过接口获取显示的图片
    async function getSelectedPhotoByAPI(showLocationId, selectedId) {
        try {
            const res = await getSelectedPhotoAPI(showLocationId, selectedId)
            return res.data
        } catch (error) {
            console.error("Error fetching photo:", error);
        }
    }

    //显示当前点击的图片类型
    async function handleClick(showLocationId, selectedId) {
        try {
            let photo = await getSelectedPhotoByAPI(showLocationId, selectedId)
            const newShowLocaiton = showLocationList.find((i) => i.id === parseInt(showLocationId))
            newShowLocaiton.photo = photo
            setShowLocationList(
                showLocationList.map((showLocation) => (showLocation.id === showLocationId ? newShowLocaiton : showLocation))
            );
        } catch (error) {
            console.error("Error fetching photo:", error);
        }
    }

    return (
        <Flex wrap="wrap" justify="center" align="center" style={{ minHeight: '400px', width: '100%' }}>
            {showLocationList.length === 0 && (
                <div className='no-data'>
                    <h2>{t('NoData')}</h2>
                    <Image
                        width={200}
                        height={200}
                        src="error"
                        fallback="data:image/png;base64,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"
                    />
                </div>
            )}
            {showLocationList.map((showLocation, index) => (
                <Card
                    size="small"
                    key={index}
                    title={showLocation.placeName}
                    hoverable
                    cover={<Image className='card-img' src={BASE_SERVER_URL_LOCAL + showLocation.photo} alt='' />}
                    className='card'
                    style={{
                        width: 300,
                    }}
                    extra={
                        <Link to={`/MyShowLocationDetail?id=${showLocation.id}`}>
                            More
                        </Link>}
                    actions={[
                        <button type='button' style={{border:'none',background:'none',padding:0,cursor:'pointer',color:'#1677ff'}} onClick={() => handleClick(showLocation.id, 0)}>起飞区域</button>,
                        <button type='button' style={{border:'none',background:'none',padding:0,cursor:'pointer',color:'#1677ff'}} onClick={() => handleClick(showLocation.id, 1)}>观看区域</button>,
                        <button type='button' style={{border:'none',background:'none',padding:0,cursor:'pointer',color:'#1677ff'}} onClick={() => handleClick(showLocation.id, 2)}>效果图</button>
                    ]}
                >
                </Card>
            ))}
        </Flex>
    )
}

export default MyShowLocationDisplay